var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {GetFirmwareUploadLinkAsync as InvokeAsync , GetFirmwareUploadLinkSync as InvokeSync}

async function GetFirmwareUploadLinkAsync(LoginToken,FirmwareUUID)
{
    var GetFirmwareUploadLinkPromise = new Promise((resolve, reject) => {
        GetFirmwareUploadLinkSync(LoginToken,FirmwareUUID,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await GetFirmwareUploadLinkPromise;
}

function GetFirmwareUploadLinkSync(LoginToken,FirmwareUUID,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/GetFirmwareUploadLink',                
        data  : {
            AppID        :KEYS.AWS_APPID,
            FirmwareUUID :FirmwareUUID,
            LoginToken   :LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
